import { useEffect, useMemo, useRef } from 'react';

import { debounce } from 'es-toolkit/compat';

export const useDebouncedCallback = <Args extends unknown[]>(callback: (...args: Args) => void, delayMs: number) => {
  const latestCallback = useRef(callback);
  latestCallback.current = callback;

  const debounced = useMemo(() => debounce((...args: Args) => latestCallback.current(...args), delayMs), [delayMs]);

  useEffect(() => () => debounced.cancel(), [debounced]);

  return debounced;
};
